// extracted by mini-css-extract-plugin
module.exports = {"users":"Users_users__14JYh","users__photo":"Users_users__photo__aKG2k","users__follow":"Users_users__follow__27_jL"};